import PropTypes from "prop-types";

function BasketMixDesktop({ config }) {
  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-basket-mix-ad.mtrix.com.br"
    ></iframe>
  );
}

BasketMixDesktop.defaultProps = {
  app: null,
  config: {},
};

BasketMixDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMixDesktop;
